import React, { useState } from "react";
import "../Details.css";
import Navbar from "../navbar";
import TableManager from "./TableManager";
import { useLocation, useParams } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

function Tables({ restaurantId: propRestaurantId, loggedInUser_Username: propUsername }) {
  const pageTitle = "Tables";

  const location = useLocation();
  const { categoryID, chartID } = useParams(); // assuming your route has :categoryID/:chartID
  console.log("Page Route: dcid:" + categoryID + " /  chid:" + chartID);

  const { user, tenantServerUrl, primaryRestaurantId } = useAuth();

  // Resolve restaurantId:
  // 1) propRestaurantId (if parent explicitly passes one)
  // 2) primaryRestaurantId from AuthContext (based on license_keys)
  const effectiveRestaurantId = propRestaurantId || primaryRestaurantId || null;

  // Resolve logged-in username:
  // 1) propUsername (if parent passes it)
  // 2) user fields from AuthContext
  // 3) localStorage fallback
  const [loggedInUser_Username] = useState(
    propUsername ||
      user?.username ||
      user?.email ||
      localStorage.getItem("loggedUser_Username") ||
      localStorage.getItem("loggedUser_Email") ||
      ""
  );

  console.log("[Tables] tenantServerUrl:", tenantServerUrl);
  console.log("[Tables] effectiveRestaurantId:", effectiveRestaurantId);
  console.log("[Tables] loggedInUser_Username:", loggedInUser_Username);

  return (
    <div className="details-container-page">
      <Navbar pageTitle={pageTitle} onToggleSidebar={true} />

      <div>
        <TableManager
          restaurantId={effectiveRestaurantId}
          loggedInUser_Username={loggedInUser_Username}
        />
      </div>
    </div>
  );
}

export default Tables;
